import script from "./OTAManagement.vue?vue&type=script&lang=ts&setup=true"
export * from "./OTAManagement.vue?vue&type=script&lang=ts&setup=true"

import "./OTAManagement.vue?vue&type=style&index=0&id=a99b7f76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a99b7f76"]])

export default __exports__